import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Box } from '@mui/material'

import { initialFormValues } from './form/initialFormValues'
import { Input } from '@components/shared/Input'
import { RowBox } from '@components/shared/RowBox'
import { setInitialFormValues } from './form/setInitialFormValues'

import type { PurchaseOrderDetailsProps } from './types'
import type { PurchaseOrderDetailsFormProps } from './form/types'

import * as S from './styles'

export const PurchaseOrderDetails = ({ mainData, data }: PurchaseOrderDetailsProps) => {
  const methods = useForm<PurchaseOrderDetailsFormProps>({
    defaultValues: initialFormValues
  })

  const handleSetInitialValues = () => {
    methods.reset(setInitialFormValues(mainData!, data!))
  }

  useEffect(() => {
    !!data && !!mainData && handleSetInitialValues()
  }, [data, mainData])

  return (
    <FormProvider {...methods}>
      <RowBox columns={4}>
        <Input name="origin" label="Origem" disabled />
        <Box sx={{ gridColumn: 'span 2' }}>
          <Input name="operation" label="Operação" disabled />
        </Box>
        <Input name="classification" label="Classificação" disabled />
        <Input name="expectedDelivery" label="Entrega Prevista" disabled />
        <Input name="itemsQuantity" label="Qtde. Itens" disabled />
        <Input
          disabled
          name="totalValue"
          label="Valor Total"
          maskType="currency"
          tooltipInfo={!data?.invoiceNumber ? 'Este valor foi utilizado na prévia de Consumo.' : null}
        />
      </RowBox>

      {/* <S.Separator />

      <RowBox columns={3} marginTop={32}>
        <S.InputsBox>
          Notas Fiscais
          <RowBox columns={2}>
            <Input name="nfItensQuantity" label="Qtde. Itens" disabled />
            <Input
              disabled
              name="nfTotalValue"
              label="Valor Total (R$)"
              maskType="currency"
              tooltipInfo={
                !!data?.invoiceNumber
                  ? 'Este valor foi utilizado na prévia de Consumo, substituindo o valor informado na Ordem de Compra correspondente.'
                  : null
              }
            />
          </RowBox>
        </S.InputsBox>

        <S.InputsBox>
          Desvio (OC x NF)
          <RowBox columns={2}>
            <Input name="deviationItensQuantity" label="Qtde. Itens" disabled />
            <Input name="deviationTotalValue" label="Valor Total (R$)" disabled maskType="currency" />
          </RowBox>
        </S.InputsBox>

        <S.InputsBox>
          Transferência OC
          <RowBox columns={2}>
            <Input name="transferItensQuantity" label="Qtde. Itens" disabled />
            <Input name="transferTotalValue" label="Valor Total (R$)" disabled maskType="currency" />
          </RowBox>
        </S.InputsBox>
      </RowBox> */}

      {/* <RowBox marginTop={16}>
        <Textarea name="observations" label="Observações" disabled={!data || !canEditPage} />
      </RowBox> */}

      <S.BottomBox>
        <Box>Para alterar dados da OC, utilize o sistema NL</Box>

        {/* {!!data && (
          <S.Buttons>
            <Button
              width={isMobile ? '100%' : 165}
              colorType="outlineBlue"
              onClick={() => {
                methods.setValue('observations', data.observation || '')
              }}
              disabled={!canEditPage}
            >
              Cancelar
            </Button>
            {canEditPage && (
              <Button
                width={isMobile ? '100%' : 165}
                colorType="solidBlue"
                onClick={methods.handleSubmit(onSubmit, onError)}
                loading={isEditItemPurchaseOrderObservationLoading}
              >
                Confirmar
              </Button>
            )}
          </S.Buttons>
        )} */}
      </S.BottomBox>
    </FormProvider>
  )
}
